export const RESPONSE = {
  CHANGE_PASSWORD_SUCCESS: 'Change password successfully. Logging out.',
  RESET_PASSWORD_SUCCESS: 'Reset password successfully. Click Proceed to login.',
  RESET_EMAIL_SENT: 'Reset password email has been sent.'
};

export const SITE_MESSAGES = {
  INTERNAL_WELCOME: 'Welcome to scoutAsia Admin Page',
  LOADING: 'Loading...'
};

export const ERROR_MESSAGE = {
  NO_PERMIT: 'You have no permit to this function, please contact Admin',
  PUBLIC_USER: 'Public user is not allow to access Admin Portal',
  DEFAULT_MESSAGE: 'Error',
};

export const CRUD_MESSAGE = {
  RETRIEVING: 'Retrieving...',
  NO_ORG: 'No Organisation',
  NO_SUB: 'No Subscription',
  NO_ROLE: 'No Role',
  NO_USER: 'No User',
  NO_CAMPAIGN: 'No Campaign',
  NO_SUB_PLAN: 'No Subscription Plan',
  NO_STAR_DATE: 'No start date',
  NO_END_DATE: 'No end date',
  NO_SAVED_SEARCH: 'No Saved Search',
  NO_TARGET_LIST: 'No Target List',
  NO_TARGET_LIST_ITEM: 'No Target',
};

export const FORM_MESSAGE = {
  CONFIRMATION_MESSAGE: 'Are you sure you want to ',
  FORGET_PWD: ' Please provide us with your email address to receive reset password email.',
  ORG_SELECT: 'Please select the organisation',
  RESET_PWD: 'Please provide your new password',
  DELETE_ITEM: 'delete',
  APPROVE_ITEM: 'approve',
  REJECT_ITEM: 'reject',
  ADD_LICENSE: 'add license to',
  CREATE_SCOUT: 'You are now creating a new',
  EDIT_SCOUT: 'You are now editing',
  PROCEED: 'Would you like to proceed?',
  EXIT: 'You are now discarding any changes made on this page, your changes will not be saved.',
};

const ACTION = {
  ADD: 'Add',
  UPDATE: 'Update',
  DELETE: 'Delete',
  RETRIEVE: 'Retrieve',
};

const ITEM = {
  TARGET_LIST: 'Target List',
  TARGET_LIST_ITEM: 'Target List Item',
  SAVED_SEARCH: 'Saved Search'
};

export const TAAS_TRAIN_STATUS = {
  SUCCESSFUL: 'Success',
  FAIL: 'Fail',
};

const PUBLIC_USER = {
  LINK_USER_SUCCESSFUL: 'Invitation sent successfully.',
  LINK_USER_FAIL: 'Invitation failed to send.',
  DELINK_USER_SUCCESSFUL: 'Remove user successfully.',
  DELINK_USER_FAIL: 'Remove user failed.',
  CHANGE_ORG_SUCCESSFUL: 'User change organisation successfully',
};

const ACCOUNT = {
  EMAIL_SENT_SUCCESS: 'Activation email sent successfully.',
  EMAIL_SENT_FAIL: 'Fail to send activation email.',
};

export const NOTIFICATION = {
  ADD_SUCCESSFUL: 'Add Successfully',
  ADD_FAIL: 'Add Failed',
  UPDATE_SUCCESSFUL: 'Update Successfully',
  UPDATE_FAIL: 'Update Failed',
  DELETE_SUCCESSFUL: 'Delete Successfully',
  DELETE_FAIL: 'Delete Failed',
  RETRIEVE_SUCCESSFUL: 'Retrieve Successfully',
  RETRIEVE_FAIL: 'Retrieve Failed',
  LIST_SUCCESSFUL: 'List Successfully',
  LIST_FAIL: 'List Failed',
  MOVE_SUCCESSFUL: 'MOVE Successfully',
  ...PUBLIC_USER,
  ...ACCOUNT,
};